// src/pages/Login.js
import React from "react";
import Header from "../components/controls/Header";
import Filters from "../components/controls/Filters";

function Welcome() {
  return (
    <div>
      <Header></Header>
      <Filters></Filters>
    </div>
  );
}

export default Welcome;
